export const forbesMockPostAnalyticsView = () => Promise.resolve({} as any);
